import EverTrue from "app";

const getUserContactIdForOrg = (user, org) => {
  if (!user.affiliations.length) return null;

  const { contact_id } = user.affiliations.find((a) => a.organization.id === org.id);
  if (!contact_id) return null;

  return contact_id.toString();
};

const assignedToSolicitorFilter = (user, org, isStageEnv) => {
  const userSolicitorContactId = getUserContactIdForOrg(user, org);
  if (!userSolicitorContactId) return null;

  return {
    label: "Assigned to Solicitor",
    compound_id: isStageEnv ? "287" : "154",
    operator: "must:in",
    value: [userSolicitorContactId],
    category: "Activity",
    group: "DXO",
    ui_component: "FilterValueMultiSelect",
    required: true,
    error_message: "Cadence constituents must be assigned to you",
  };
};

const stageFilter = (isStageEnv, journeyType) => {
  // TODO: REFACTOR
  let stageVal;
  if (!journeyType) stageVal = "Open";
  else {
    const lower = journeyType.toLowerCase();
    stageVal = lower.charAt(0).toUpperCase() + lower.slice(1);
  }

  return {
    label: "Stage",
    compound_id: isStageEnv ? "286" : "155",
    operator: "must:in",
    value: [stageVal],
    category: "Activity",
    group: "DXO",
    ui_component: "FilterValueMultiSelect",
    required: true,
    error_message: "Access constituents in other cadences using the top navigation",
  };
};

export const buildDefaultQuery = (user, org, journey) => {
  const isStageEnv = EverTrue.config.environment_data === "Stage";

  return {
    quick_filters: [],
    filters: {
      blocks: [
        {
          condition: "and_all_of",
          rules: [
            // ADD MORE DEFAULT FILTERS HERE IF YOU WANT
            assignedToSolicitorFilter(user, org, isStageEnv),
            stageFilter(isStageEnv, journey.journey_type),
          ].filter((e) => e !== null),
        },
        {
          condition: "and_all_of",
          rules: [{}],
        },
      ],
    },
  };
};
